import styled from "styled-components";
import { Button } from "@mui/material";

export const StyledIconButton = styled(Button)`
  text-transform: none;
  text-align: left;
`;
